export default __webpack_public_path__ + "media/plus/header-3560aa63.png";